import { createContext, useState } from "react";
import { toast } from "react-toastify";
import { MessageToast } from "../../style/messageToast";
import { iProductsProps } from "../UserContext/types";
import { iCartContext, iCartProvider, iProductsCart } from "./types";
import { useEffect } from "react";

export const CartContext = createContext({} as iCartContext);

export const CartProvider = ({ children }: iCartProvider) => {
  const [cart, setCart] = useState([] as iProductsCart[]);
  const [modal, setModal] = useState(false);
  const [cartTotal, setCartTotal] = useState(0);

  const productAdd = (product: iProductsProps) => {
    if (!cart.find((currentItem) => currentItem.id === product.id)) {
      setCart([...cart, { ...product, quantity: 1 }]);
      toast.success(<MessageToast message="Item adicionado com sucesso" />);
    } else {
      const attQuantity = cart.map((currentItem) => {
        if (currentItem.quantity) {
          return currentItem.id === product.id
            ? { ...currentItem, quantity: (currentItem.quantity += 1) }
            : currentItem;
        } else {
          return currentItem;
        }
      });
      setCart(attQuantity);
      toast.success(<MessageToast message="Item adicionado com sucesso" />);
    }
  };

  const addCountProduct = (id: number) => {
    const addItem = cart.map((currentItem) => {
      if (currentItem.quantity) {
        return currentItem.id === id
          ? { ...currentItem, quantity: (currentItem.quantity += 1) }
          : currentItem;
      } else {
        return currentItem;
      }
    });
    setCart(addItem);
  };

  const subCountProduct = (id: number) => {
    const item = cart.find((currentItem) => currentItem.id === id);
    const filter = cart.filter((currentItem) => currentItem.id !== id);
    if (item?.quantity) {
      if (item.quantity > 1) {
        const subItem = cart.map((currentItem) => {
          if (currentItem.quantity && currentItem.quantity > 1) {
            return currentItem.id === id
              ? { ...currentItem, quantity: (currentItem.quantity -= 1) }
              : currentItem;
          } else {
            return currentItem;
          }
        });
        setCart(subItem);
      } else {
        setCart(filter);
      }
    }
  };

  const removeButton = (id: number) => {
    const filter = cart.filter((currentItem) => currentItem.id !== id);
    setCart(filter);
  };

  useEffect(() => {
    (() => {
      const value = cart.reduce((acc, prevValue) => {
        if (prevValue.quantity) {
          return acc + prevValue.price * prevValue.quantity;
        } else {
          return 0;
        }
      }, 0);
      setCartTotal(value);
    })();
  }, [cart]);

  return (
    <CartContext.Provider
      value={{
        setCart,
        cart,
        modal,
        setModal,
        productAdd,
        addCountProduct,
        subCountProduct,
        cartTotal,
        removeButton,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
